import { baseFacetResponseSelector } from '../facet-set/facet-set-selectors.js';
import { findActiveValueAncestry } from './category-facet-utils.js';
function isCategoryFacetResponse(state, response) {
    return !!response && response.facetId in state.categoryFacetSet;
}
export const categoryFacetResponseSelector = (state, facetId) => {
    const response = baseFacetResponseSelector(state, facetId);
    if (isCategoryFacetResponse(state, response)) {
        return response;
    }
    return undefined;
};
export const categoryFacetRequestSelector = (state, id) => {
    return state.categoryFacetSet[id]?.request;
};
export const categoryFacetResponseSelectedValuesSelector = (state, facetId) => {
    const facetResponse = categoryFacetResponseSelector(state, facetId);
    return findActiveValueAncestry(facetResponse?.values ?? []);
};
export const categoryFacetRequestSelectedValuesSelector = (state, facetId) => {
    const facetRequest = categoryFacetRequestSelector(state, facetId);
    return findActiveValueAncestry(facetRequest?.currentValues ?? []);
};
